const sanitizeHTML = str => {
  return str && typeof str === "string"
    ? str
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
    : str;
};

const sanitizeHTMLExceptQuotes = str => {
  return str && typeof str === "string"
    ? str.replace(/</g, "&lt;").replace(/>/g, "&gt;")
    : str;
};

export { sanitizeHTML, sanitizeHTMLExceptQuotes };
